<template>
  <svg
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.63891 9.87488C3.51003 9.74596 3.43762 9.57112 3.43762 9.38882C3.43762 9.20652 3.51003 9.03168 3.63891 8.90276L7.04204 5.49963L3.63891 2.09651C3.51368 1.96684 3.44438 1.79318 3.44595 1.61292C3.44752 1.43266 3.51982 1.26022 3.64729 1.13276C3.77476 1.00529 3.94719 0.932984 4.12745 0.931417C4.30771 0.929852 4.48137 0.999147 4.61104 1.12438L8.50023 5.01357C8.62911 5.14249 8.70152 5.31733 8.70152 5.49963C8.70152 5.68193 8.62911 5.85677 8.50023 5.98569L4.61104 9.87488C4.48211 10.0038 4.30728 10.0762 4.12498 10.0762C3.94267 10.0762 3.76784 10.0038 3.63891 9.87488Z"
      fill="#545454"
    />
    <path
      d="M8.63891 9.87488C8.51003 9.74596 8.43762 9.57112 8.43762 9.38882C8.43762 9.20652 8.51003 9.03168 8.63891 8.90276L12.042 5.49963L8.63891 2.09651C8.51368 1.96684 8.44438 1.79318 8.44595 1.61292C8.44752 1.43266 8.51982 1.26022 8.64729 1.13276C8.77476 1.00529 8.94719 0.932984 9.12745 0.931417C9.30771 0.929852 9.48137 0.999147 9.61104 1.12438L13.5002 5.01357C13.6291 5.14249 13.7015 5.31733 13.7015 5.49963C13.7015 5.68193 13.6291 5.85677 13.5002 5.98569L9.61104 9.87488C9.48211 10.0038 9.30728 10.0762 9.12498 10.0762C8.94267 10.0762 8.76784 10.0038 8.63891 9.87488Z"
      fill="#545454"
    />
  </svg>
</template>
